// extracted by mini-css-extract-plugin
module.exports = {"AuthLayout":"AuthLayout_AuthLayout__XYehj"};